import React, { useState, useEffect } from 'react';
import match5Image1 from '../matchesimages/match5/1.JPG';
import match5Image2 from '../matchesimages/match5/2.jpg';
import match5Image3 from '../matchesimages/match5/3.jpg';
import match5Image4 from '../matchesimages/match5/4.jpg';
import match5Image5 from '../matchesimages/match5/5.jpg';

import match6Image1 from '../matchesimages/match6/1.JPG';
import match6Image2 from '../matchesimages/match6/2.jpg';
import match6Image3 from '../matchesimages/match6/3.jpg';
import match6Image4 from '../matchesimages/match6/4.jpg';
import match6Image5 from '../matchesimages/match6/5.jpg';
import match6Image6 from '../matchesimages/match6/6.jpg';

import match7Image1 from '../matchesimages/match7/1.JPG';
import match7Image2 from '../matchesimages/match7/2.JPG';
import match7Image3 from '../matchesimages/match7/3.JPG';
import match7Image4 from '../matchesimages/match7/4.JPG';
import match7Image5 from '../matchesimages/match7/5.JPG';
import match7Image6 from '../matchesimages/match7/6.JPG';
import match7Image7 from '../matchesimages/match7/7.JPG';
import match7Image8 from '../matchesimages/match7/8.JPG';
import match7Image9 from '../matchesimages/match7/9.JPG';
import match7Image10 from '../matchesimages/match7/10.JPG';

import match8Image1 from '../matchesimages/match8/1.JPG';
import match8Image2 from '../matchesimages/match8/2.JPG';
import match8Image3 from '../matchesimages/match8/3.JPG';
import match8Image4 from '../matchesimages/match8/4.JPG';
import match8Image5 from '../matchesimages/match8/5.JPG';
import match8Image6 from '../matchesimages/match8/6.JPG';
import match8Image7 from '../matchesimages/match8/7.JPG';
import match8Image8 from '../matchesimages/match8/8.JPG';
import match8Image9 from '../matchesimages/match8/9.JPG';
import match8Image10 from '../matchesimages/match8/10.JPG';

import match11Image1 from '../matchesimages/match11/1.JPG';
import match11Image2 from '../matchesimages/match11/2.JPG';
import match11Image3 from '../matchesimages/match11/3.JPG';
import match11Image4 from '../matchesimages/match11/4.JPG';
import match11Image5 from '../matchesimages/match11/5.JPG';
import match11Image6 from '../matchesimages/match11/6.JPG';
import match11Image7 from '../matchesimages/match11/7.JPG';
import match11Image8 from '../matchesimages/match11/8.JPG';
import match11Image9 from '../matchesimages/match11/9.JPG';
import match11Image10 from '../matchesimages/match11/10.JPG';

import match12Image1 from '../matchesimages/match12/1.JPG';
import match12Image2 from '../matchesimages/match12/2.JPG';
import match12Image3 from '../matchesimages/match12/3.JPG';
import match12Image4 from '../matchesimages/match12/4.JPG';
import match12Image5 from '../matchesimages/match12/5.JPG';
import match12Image6 from '../matchesimages/match12/6.JPG';
import match12Image7 from '../matchesimages/match12/7.JPG';
import match12Image8 from '../matchesimages/match12/8.JPG';
import match12Image9 from '../matchesimages/match12/9.JPG';
import match12Image10 from '../matchesimages/match12/10.JPG';

import match13Image1 from '../matchesimages/match13/1.jpg';
import match13Image2 from '../matchesimages/match13/2.JPG';
import match13Image3 from '../matchesimages/match13/3.JPG';
import match13Image4 from '../matchesimages/match13/4.JPG';
import match13Image5 from '../matchesimages/match13/5.JPG';
import match13Image6 from '../matchesimages/match13/6.JPG';
import match13Image7 from '../matchesimages/match13/7.jpg';
import match13Image8 from '../matchesimages/match13/8.jpg';
import match13Image9 from '../matchesimages/match13/9.jpg';
import match13Image10 from '../matchesimages/match13/10.jpg';

import match14Image1 from '../matchesimages/match14/1.jpg';
import match14Image2 from '../matchesimages/match14/2.jpg';
import match14Image3 from '../matchesimages/match14/3.jpg';
import match14Image4 from '../matchesimages/match14/4.jpg';
// import match14Image5 from '../matchesimages/match14/5.jpg';
// import match14Image6 from '../matchesimages/match14/6.jpg';
import match14Image7 from '../matchesimages/match14/7.jpg';
import match14Image8 from '../matchesimages/match14/8.jpg';
import match14Image9 from '../matchesimages/match14/9.JPG';
// import match14Image10 from '../matchesimages/match14/10.jpg';

// Match data with all matches
const matches = [
  { id: 'match1', title: 'Noida Thunders Vs Lucknow Tigers', date: 'Aug 07, 2025' },
  { id: 'match2', title: 'Ayodhya Super Kings Vs Gorakhpur Giants', date: 'Aug 07, 2025' },
  { id: 'match3', title: 'Kashi Warriors Vs Muzaffarnagar Lions', date: 'Aug 08, 2025' },
  { id: 'match4', title: 'Moradabad Bulls Vs Mathura Yodhas', date: 'Aug 08, 2025' },
  { id: 'match5', title: 'Lucknow Tigers Vs Ayodhya Super Kings', date: 'Aug 09, 2025' },
  { id: 'match6', title: 'Kashi Warriors Vs Noida Thunders', date: 'Aug 09, 2025' },
  { id: 'match7', title: 'Mathura Yodhas Vs Gorakhpur Giants', date: 'Aug 10, 2025' },
  { id: 'match8', title: 'Muzaffarnagar Lions Vs Moradabad Bulls', date: 'Aug 10, 2025' },
  { id: 'match9', title: 'Noida Thunders Vs Mathura Yodhas', date: 'Aug 11, 2025' },
  { id: 'match10', title: 'Kashi Warriors Vs Lucknow Tigers', date: 'Aug 11, 2025' },
  { id: 'match11', title: 'Moradabad Bulls Vs Gorakhpur Giants', date: 'Aug 12, 2025' },
  { id: 'match12', title: 'Muzaffarnagar Lions Vs Ayodhya Super Kings', date: 'Aug 12, 2025' },
  { id: 'match13', title: 'Kashi Warriors Vs Moradabad Bulls', date: 'Aug 13, 2025' },
  { id: 'match14', title: 'Lucknow Tigers Vs Mathura Yodhas', date: 'Aug 13, 2025' },
  { id: 'match15', title: 'Noida Thunders Vs Ayodhya Super Kings', date: 'Aug 14, 2025' },
  { id: 'match16', title: 'Muzaffarnagar Lions Vs Gorakhpur Giants', date: 'Aug 14, 2025' },
  { id: 'match17', title: 'Kashi Warriors Vs Mathura Yodhas', date: 'Aug 15, 2025' },
  { id: 'match18', title: 'Moradabad Bulls Vs Ayodhya Super Kings', date: 'Aug 15, 2025' },
  { id: 'match19', title: 'Muzaffarnagar Lions Vs Lucknow Tigers', date: 'Aug 16, 2025' },
  { id: 'match20', title: 'Noida Thunders Vs Gorakhpur Giants', date: 'Aug 16, 2025' },
  { id: 'match21', title: 'TBA1 Vs TBA2', date: 'Aug 17, 2025' },
  { id: 'match22', title: 'TBA1 Vs TBA2', date: 'Aug 18, 2025' },
  { id: 'match23', title: 'TBA1 Vs TBA2', date: 'Aug 19, 2025' },
  { id: 'match24', title: 'TBA1 Vs TBA2', date: 'Aug 20, 2025' },
  { id: 'match25', title: 'TBA1 Vs TBA2', date: 'Aug 21, 2025' },
];

// Image data with categories (replace with your actual Cloudinary links)
const galleryData = {
  'trial': [
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203159/G9_ucfkyw.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203158/G8_foax4t.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203157/G7_ysqfcr.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203156/G5_h20z3s.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203156/G4_o9keeb.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203153/G12_ylwmj7.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203152/G10_ku6ijf.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203152/G11_omv8rk.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203149/G3_gskh7f.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203149/G2_j5r7gu.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203148/Gallery_40_cyyflu.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203147/G1_ttayov.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203147/Gallery_39_s7vmco.jpg',
  ],
  'trophy-launch': [
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203227/Gallery_38_pikvvn.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203226/Gallery_37_fs6shi.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203225/Gallery_36_tynhjy.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203224/Gallery_35_nwqaio.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203223/Gallery_34_eieofw.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203222/Gallery_33_s1xnt1.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203221/Gallery_32_ujegz1.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203220/Gallery_31_hzbj6i.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203219/Gallery_30_hxgimn.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203218/Gallery_29_zcw5iv.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203218/Gallery_28_h4qwm8.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203215/Gallery_27_px5vkc.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203214/Gallery_26_cnjkb1.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203212/Gallery_25_bhnkct.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203211/Gallery_24_ebq6re.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203211/Gallery_23_azqbzo.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203210/Gallery_22_zymdyu.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203209/Gallery_21_z7ccod.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203209/Gallery_20_ccdaaf.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203208/Gallery_19_cufwws.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203207/Gallery_18_hyymyf.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203206/Gallery_17_rfoxrt.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203206/Gallery_16_ikzdc0.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203205/Gallery_15_yn0zrg.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203188/Gallery_14_b26fn6.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203187/Gallery_13_mhbppl.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203187/Gallery_12_djf6ur.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203187/Gallery_11_hsktbf.jpg',
  ],
  'auction': [
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203047/G29_ji8rql.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203044/G30_dhzczi.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203043/G27_aofzrx.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203041/G22_gljzu3.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203041/G26_mvhbfj.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203039/G24_jcafuz.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203039/G23_ax2101.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203038/G20_tokn5j.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203038/G21_zdmam8.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203035/G13_cgcx2o.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203034/G19_xbdoq1.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203034/G17_hb23yy.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203034/G14_hihdqp.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203034/G18_lnaunx.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203033/G15_bixeil.jpg',
    'https://res.cloudinary.com/dctkzy9nd/image/upload/v1754203031/G25_mbn94i.jpg',
  ],
  'match-day': {
  'match1': [
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754942159/AKY08979_wuzomi.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754942159/AKY09099_omcvzw.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754942158/AKY08652_gz2vui.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754942154/AKY08788_smlgmb.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754942153/AKY08902_wohxla.jpg',
  ],
  'match2': [
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943662/MRP03450_rt9ou2.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943659/MRP03655_fyhejm.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943659/MRP03701_moqmri.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943658/MRP03691_k16xqn.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943657/MRP03630_bcntcq.jpg',
  ],
  'match3': [
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943559/AKY09789_etmrjf.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943555/DSC01331_oierh8.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943550/DSC01257_cfjukr.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943550/MRP04570_t0rnmj.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943549/MRP04596_o9hpbe.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943548/MRP04457_jfuz5f.jpg',
  ],
  'match4': [
    // 'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943499/AKY09789_ruru9s.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943148/AKY00194_wwmors.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943148/AKY00099_wvow6c.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943147/DSC01459_zhp2uv.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943146/AKY00138_ywbxvz.jpg',
    'https://res.cloudinary.com/dbcr3ezhh/image/upload/v1754943144/DSC01462_fjwodn.jpg',
  ],
  'match5':[
    match5Image1,
    match5Image2,
    match5Image3,
    match5Image4,
    match5Image5,
  ],
  'match6':[
    match6Image1,
    match6Image2,
    match6Image3,
    match6Image4,
    match6Image5,
    match6Image6,
  ],
  'match7':[
    match7Image1,
    match7Image2,
    match7Image3,
    match7Image4,
    match7Image5,
    match7Image6,
    match7Image7,
    match7Image8,
    match7Image9,
    match7Image10,
  ],
  'match8':[
    match8Image1,
    match8Image2,
    match8Image3,
    match8Image4,
    match8Image5,
    match8Image6,
    match8Image7,
    match8Image8,
    match8Image9,
    match8Image10,
  ],
  'match11':[
    match11Image1,
    match11Image2,
    match11Image3,
    match11Image4,
    match11Image5,
    match11Image6,
    match11Image7,
    match11Image8,
    match11Image9,
    match11Image10,
  ],
  'match12':[
    match12Image1,
    match12Image2,
    match12Image3,
    match12Image4,
    match12Image5,
    match12Image6,
    match12Image7,
    match12Image8,
    match12Image9,
    match12Image10,
  ],
  'match13':[
    match13Image1,
    match13Image2,
    match13Image3,
    match13Image4,
    match13Image5,
    match13Image6,
    match13Image7,
    match13Image8,
    match13Image9,
    match13Image10,
  ],
  'match14':[
    match14Image1,
    match14Image2,
    match14Image3,
    match14Image4,
    match14Image7,
    match14Image8,
  ],
  
}
};

export default function Gallery() {
  const [activeCategory, setActiveCategory] = useState('trial');
  const [selectedMatch, setSelectedMatch] = useState('match1');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [activeCategory, selectedMatch]);

  const currentMatch = matches.find(match => match.id === selectedMatch) || matches[0];

  const filteredImages = activeCategory === 'match-day' 
    ? (galleryData[activeCategory][selectedMatch] || []).filter(img => img && img.trim() !== '')
    : galleryData[activeCategory].filter(img => img && img.trim() !== '');

  return (
    <div className="gallery-page" style={{ backgroundColor: '#0A1434' }}>
      <div className="breadcrumb-container">
        <div className="breadcrumb-overlay">
          <div className="breadcrumb-content">
            <h1 className="breadcrumb-title">Gallery</h1>
          </div>
        </div>
      </div>

      <div className="gallery-container">
        {/* Filter Buttons */}
        <div className="filter-buttons">
          {Object.keys(galleryData).map((category) => (
            <button
              key={category}
              className={`filter-button ${activeCategory === category ? 'active' : ''}`}
              onClick={() => {
                setLoading(true);
                setActiveCategory(category);
                if (category === 'match-day') {
                  setSelectedMatch('match1');
                }
              }}
            >
              {category.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
            </button>
          ))}
        </div>

        {/* Match Day Selector */}
        {activeCategory === 'match-day' && (
          <div className="match-selector-container">
            <select
              className="match-selector"
              value={selectedMatch}
              onChange={(e) => {
                setLoading(true);
                setSelectedMatch(e.target.value);
              }}
            >
              {matches.map((match) => (
                <option key={match.id} value={match.id}>
                  {match.id.replace('match', 'Match ')}: {match.title}, {match.date}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Match Title */}
        {activeCategory === 'match-day' && (
          <div className="match-title-container">
            <h2 className="match-title">
              {currentMatch.id.replace('match', 'Match ')}: {currentMatch.title}
            </h2>
            <p className="match-date">{currentMatch.date}</p>
          </div>
        )}

        {/* Gallery Content */}
        <div className="gallery-content">
          {loading ? (
            <div className="skeleton-grid">
              {[...Array(6)].map((_, index) => (
                <div key={index} className="skeleton-item">
                  <div className="skeleton-image"></div>
                </div>
              ))}
            </div>
          ) : filteredImages.length === 0 ? (
            <div className="no-images-message">
              <p>Images for {activeCategory === 'match-day' ? currentMatch.title : activeCategory.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} will be available soon</p>
            </div>
          ) : (
            <div className="gallery-grid">
              {filteredImages.map((imgSrc, index) => (
                <div key={index} className="gallery-item">
                  <img 
                    src={imgSrc} 
                    alt={`${activeCategory === 'match-day' ? currentMatch.title : activeCategory.replace('-', ' ')} ${index + 1}`}
                    className="gallery-image"
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = 'data:image/svg+xml;charset=UTF-8,%3Csvg xmlns="http://www.w3.org/2000/svg" width="500" height="300" viewBox="0 0 500 300"%3E%3Crect fill="%231a2342" width="500" height="300"/%3E%3Ctext fill="%23ffffff" font-family="Arial" font-size="16" x="50%" y="50%" text-anchor="middle" dominant-baseline="middle"%3EImage coming soon%3C/text%3E%3C/svg%3E';
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .gallery-page {
          min-height: 100vh;
          color: white;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .breadcrumb-container {
          position: relative;
          height: 300px;
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 40px;
        }

        .breadcrumb-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .breadcrumb-content {
          text-align: center;
          color: white;
          z-index: 1;
        }

        .breadcrumb-title {
          font-size: 3rem;
          font-weight: 700;
          margin: 0;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .gallery-container {
          width: 100%;
          max-width: 1700px;
          margin: 0 auto;
          padding: 0 20px 60px;
        }

        .filter-buttons {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 15px;
          margin-bottom: 30px;
        }

        .filter-button {
          padding: 10px 25px;
          font-size: 1rem;
          border-radius: 30px;
          border: 2px solid #FFCA49;
          background-color: transparent;
          color: #FFCA49;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: capitalize;
          font-weight: 500;
        }

        .filter-button:hover {
          background-color: rgba(255, 202, 73, 0.1);
        }

        .filter-button.active {
          background-color: #FFCA49;
          color: #0A1434;
          font-weight: 600;
        }

        .match-selector-container {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
        }

        .match-selector {
          padding: 10px 15px;
          font-size: 1rem;
          border-radius: 8px;
          border: 2px solid #FFCA49;
          background-color: #0A1434;
          color: white;
          cursor: pointer;
          max-width: 100%;
          width: 500px;
          text-overflow: ellipsis;
        }

        .match-title-container {
          text-align: center;
          margin-bottom: 30px;
        }

        .match-title {
          font-size: 1.8rem;
          color: #FFCA49;
          margin-bottom: 5px;
        }

        .match-date {
          font-size: 1.2rem;
          color: #aaa;
          margin: 0;
        }

        .gallery-content {
          width: 100%;
        }

        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 40px;
        }

        .gallery-item {
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
          transition: transform 0.3s ease;
        }

        .gallery-item:hover {
          transform: translateY(-5px);
        }

        .gallery-image {
          width: 100%;
          height: 300px;
          object-fit: cover;
          display: block;
          border: 5px solid #FFCA49;
        }

        .no-images-message {
          text-align: center;
          padding: 60px 20px;
          font-size: 1.2rem;
          color: #FFCA49;
          background-color: rgba(26, 35, 66, 0.5);
          border-radius: 8px;
          margin: 20px 0;
        }

        .skeleton-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .skeleton-item {
          border-radius: 8px;
          overflow: hidden;
        }

        .skeleton-image {
          width: 100%;
          height: 300px;
          background-color: #1a2342;
          animation: pulse 1.5s infinite ease-in-out;
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 0.6;
          }
          50% {
            opacity: 0.3;
          }
        }

        @media (max-width: 1200px) {
          .gallery-grid,
          .skeleton-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }
        }

        @media (max-width: 992px) {
          .gallery-grid,
          .skeleton-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .match-title {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 768px) {
          .breadcrumb-title {
            font-size: 2.2rem;
          }

          .filter-buttons {
            gap: 10px;
          }

          .filter-button {
            padding: 8px 20px;
            font-size: 0.9rem;
          }

          .gallery-image,
          .skeleton-image {
            height: 250px;
          }
          
          .match-selector {
            width: 100%;
          }
          
          .match-title {
            font-size: 1.3rem;
          }
        }

        @media (max-width: 576px) {
          .breadcrumb-container {
            height: 250px;
          }

          .breadcrumb-title {
            font-size: 1.8rem;
          }

          .filter-buttons {
            gap: 8px;
          }

          .filter-button {
            padding: 6px 15px;
            font-size: 0.8rem;
          }

          .gallery-grid,
          .skeleton-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }

          .gallery-image,
          .skeleton-image {
            height: 300px;
          }
          
          .match-title {
            font-size: 1.1rem;
          }
          
          .match-date {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
}